import { render } from "./TaskModal.vue?vue&type=template&id=37f3a2dc"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/aft/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__